import { LoginPayload, LoginResponse } from "../../../../models/User";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function forgotPasswordAuth(data: { EMAIL: string }) {
  const res = await ApiClient.post(`/ForgotPasswordAuth`, data);
  return res.data;
}

export const useForgotPasswordAuth = mutationWrapper(forgotPasswordAuth);
